import icon_plus from '@/pages/ISWAN_CHAT/AIChatNew/image/icon_plus.png';
import FillImage from '@/pages/ISWAN_CHAT/components/FillImage/FillImage';
import './NewChatButton.less';

export interface NewChatButtonProps {
  onClick?: () => void;
}

const NewChatButton = (props: NewChatButtonProps) => {
  return (
    <>
      <div className={'s_newButton'} onClick={props?.onClick}>
        <div className={'s_newButton_plusIcon'}>
          <FillImage src={icon_plus} />
        </div>
        <div>新对话</div>
      </div>
    </>
  );
};

export default NewChatButton;
